export const APP_NAME = 'Rout';
//# sourceMappingURL=brand.js.map